import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { m } from 'framer-motion';
import styled from 'styled-components';
import { BookEventFormStyles, labelBase } from '../../BookEventForm.styles';
const Container = styled(BookEventFormStyles.FormBase) ``;
const Collapsible = styled(m.div).attrs(({ active }) => ({
    initial: 'hidden',
    animate: active ? 'visible' : 'hidden',
    variants: {
        hidden: {
            height: '0px',
        },
        visible: {
            height: 'auto',
        },
    },
    transition: {
        bounce: 0,
    },
})) `
  overflow: hidden;
`;
const AttendeeFormWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
const AttendeeFormTitle = styled.div `
  ${fonts.lato.semiBold};

  display: flex;
  font-size: ${fluid(18, 20)};
  cursor: pointer;

  svg {
    margin-left: auto;
    width: 20px;

    ${transition('transform', 0.25, 'easeInOut')}
    [data-active='true'] & {
      transform: rotate(180deg);
    }
  }

  span {
    display: inline-flex;
    background-color: ${brand.validation.invalid};
    color: ${brand.white};
    height: 20px;
    width: 20px;
    justify-content: center;
    align-items: center;
    font-size: 66%;
    margin-right: 6px;
    border-radius: 5000px;
  }
`;
const AttendeeFormInner = styled.div `
  display: flex;
  flex-direction: column;
`;
const AddLater = styled.details `
  margin-bottom: ${fluid(28, 40)};

  summary {
    ${labelBase};

    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 12px;

    svg {
      ${transition('transform', 0.25)};

      width: 14px;
    }
  }

  &[open] svg {
    transform: rotate(180deg);
  }
`;
const FormWrapper = styled.div `
  display: block;

  ${transition('opacity', 0.25, 'easeInOut')}
  opacity: 1;

  &[data-disabled='true'] {
    opacity: 0.5;
    pointer-events: none;
  }
`;
export const StepTwoStyles = {
    Container,
    Collapsible,
    AttendeeFormWrapper,
    AttendeeFormTitle,
    AttendeeFormInner,
    AddLater,
    FormWrapper,
};
